var map = {
	"./birthday-cards/1143w-Ni52BwQiRDE.webp": 898,
	"./birthday-cards/360_F_359384136_6gE8DpsW2rfhCPGT4vLJqPDCtEnzSlNO.jpg": 1298,
	"./birthday-cards/60th-Birthday-Party-Card-Template.jpeg": 3422,
	"./birthday-cards/Birthday-ClassicGeneric.webp": 6537,
	"./birthday-cards/P1019274-scaled.jpg": 6520,
	"./birthday-cards/happy-birthday-card-design-template-cae53ef3f35cea471ddee4aa15149fd9_screen.jpg": 2815,
	"./birthday-cards/happy-birthday-greeting-card-design-template-8d794c47a93481bf3db253753508c59c_screen.jpg": 5154,
	"./birthday-cards/happy-birthday-greeting-card-with-flowers-birthday-card-design-with-congratulatory-text-vector-illustration-eps10-700-235893077.jpg": 4918,
	"./business-cards/0645f5918108ca2b060bc01094593f30.jpg": 1777,
	"./business-cards/1f406046a9c0c95766b8e072ad5277a0.jpg": 5732,
	"./business-cards/cc5473a79006bfceef80abe5f1dfe3fa.jpg": 7948,
	"./business-cards/download.webp": 4189,
	"./business-cards/original-c7920f0a640584755c5d1b07e917430e.webp": 7933,
	"./business-cards/st-QC4U-WFOuZwdoEV7Yo.jpeg": 4053,
	"assets/inspiration/birthday-cards/1143w-Ni52BwQiRDE.webp": 898,
	"assets/inspiration/birthday-cards/360_F_359384136_6gE8DpsW2rfhCPGT4vLJqPDCtEnzSlNO.jpg": 1298,
	"assets/inspiration/birthday-cards/60th-Birthday-Party-Card-Template.jpeg": 3422,
	"assets/inspiration/birthday-cards/Birthday-ClassicGeneric.webp": 6537,
	"assets/inspiration/birthday-cards/P1019274-scaled.jpg": 6520,
	"assets/inspiration/birthday-cards/happy-birthday-card-design-template-cae53ef3f35cea471ddee4aa15149fd9_screen.jpg": 2815,
	"assets/inspiration/birthday-cards/happy-birthday-greeting-card-design-template-8d794c47a93481bf3db253753508c59c_screen.jpg": 5154,
	"assets/inspiration/birthday-cards/happy-birthday-greeting-card-with-flowers-birthday-card-design-with-congratulatory-text-vector-illustration-eps10-700-235893077.jpg": 4918,
	"assets/inspiration/business-cards/0645f5918108ca2b060bc01094593f30.jpg": 1777,
	"assets/inspiration/business-cards/1f406046a9c0c95766b8e072ad5277a0.jpg": 5732,
	"assets/inspiration/business-cards/cc5473a79006bfceef80abe5f1dfe3fa.jpg": 7948,
	"assets/inspiration/business-cards/download.webp": 4189,
	"assets/inspiration/business-cards/original-c7920f0a640584755c5d1b07e917430e.webp": 7933,
	"assets/inspiration/business-cards/st-QC4U-WFOuZwdoEV7Yo.jpeg": 4053
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3411;